import { Stack, Typography } from '@mui/material';
import { FC, memo, useCallback } from 'react';

import { VpIcon } from '@vp/common/ui/component/VpIcon';

export type AccessManagerActionButtonProps = {
  Icon: FC;
  text: string;
  disabled: boolean;
  onClick: () => void;
};

export const AccessManagerActionButton = memo<AccessManagerActionButtonProps>(({ Icon, text, disabled, onClick }) => {
  const handleClick = useCallback(() => {
    if (!disabled) {
      onClick();
    }
  }, [disabled, onClick]);

  return (
    <Stack
      direction="row"
      gap={1}
      sx={{
        cursor: !disabled ? 'pointer' : 'initial',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        opacity: disabled ? 0.75 : 1,
        '&:active': {
          opacity: !disabled ? 0.5 : undefined,
        },
      }}
      onClick={handleClick}
    >
      <VpIcon Icon={Icon} size={20} glowing />

      <Typography
        variant="buttonMedium"
        color="primary.500"
        sx={{ textShadow: '0px 0px 32px rgba(255, 255, 255, 0.5), 0px 0px 128px rgba(255, 255, 255, 0.5)' }}
      >
        {text}
      </Typography>
    </Stack>
  );
});

AccessManagerActionButton.displayName = 'AccessManagerGenerateButton';
